var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm.is_loaded
      ? _c(
          "div",
          {
            staticStyle: {
              "max-width": "1320px",
              margin: "auto",
              padding: "10px 20px 0",
            },
          },
          [
            _c("div", { staticClass: "pta-meeting-head" }, [
              _c("h2", [_vm._v("Fact Sheet")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.user.profile.company))]),
              _vm._v(" "),
              _c("ul", { staticClass: "mm-links" }, [
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "mm-link-pdf",
                      attrs: { href: "/fs/" + _vm.user.id + "/pdf" },
                    },
                    [_vm._v("PDF")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "mm-link-word",
                      attrs: { href: "/fs/" + _vm.user.id + "/doc" },
                    },
                    [_vm._v("Word")]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pta-factsheet" }, [
              _c("div", { staticClass: "pta-factsheet-left" }, [
                _c("div", { staticClass: "pta-factsheet-box" }, [
                  _c("h3", [_vm._v("About the Manager / Sponsor")]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "pta-factsheet-box-content",
                    staticStyle: { "text-align": "center" },
                    domProps: { innerHTML: _vm._s(_vm.typeValueSponsors) },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pta-factsheet-box" }, [
                  _c("h3", [
                    _vm._v("Key Differentiators / Track Record Highlights"),
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "pta-factsheet-box-content",
                    domProps: { innerHTML: _vm._s(_vm.typeValueTR) },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-factsheet-right" }, [
                _c("div", { staticClass: "pta-factsheet-box" }, [
                  _c("h3", [_vm._v("About the Offering")]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "pta-factsheet-box-content",
                    staticStyle: { "text-align": "center" },
                    domProps: { innerHTML: _vm._s(_vm.typeValueOffer) },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pta-factsheet-box" }, [
                  _c("h3", [_vm._v("Key Terms")]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "pta-factsheet-box-content",
                    domProps: { innerHTML: _vm._s(_vm.typeValueTerms) },
                  }),
                ]),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { padding: "20px" } }, [
      _c("a", { attrs: { href: "/", title: "Home" } }, [
        _c("img", {
          staticClass: "header-logo",
          attrs: {
            src: "/images/logo.svg",
            width: "246",
            height: "42",
            alt: "",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }